/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import getCurrentUserId from './get-current-user-id';

export default (state) => {
    const userId = getCurrentUserId(state);

    if (!userId) {
        return null;
    }

    return get(state, ['currentUser']);
};
